<template>
  <b-row>
    <b-col>
      <div class="d-flex justify-content-between mb-4">
        <div class="h5 font-weight-bold font-size-lg d-flex align-items-center">Posts list</div>
        <div v-if="editable">
          <b-button
            ref="button__create-post"
            variant="first"
            :disabled="disabled"
            class="ml-3 button__create-new-post"
            @click="goToCreatePost"
          >
            <span>Create new post</span>
          </b-button>
          <!-- <b-dropdown
            right
            no-caret
            variant="link btn-link-primary"
            class="text-primary"
          >
            <template #button-content>
              <b-button variant="secondary" size="sm">
                <font-awesome-icon icon="cog" />
              </b-button>
            </template>
            <slot>
              <b-dropdown-item @click.prevent.stop="fetchPostsForReorder">
                Reorder
              </b-dropdown-item>
            </slot>
          </b-dropdown>

          <BaseModalReorder
            :ref="`Reorder`"
            :items="postsForReorder"
            :is-fetching="isLoading"
            @emitReorderItems="ReorderItems"
          /> -->
        </div>
      </div>

      <div v-if="isLoading" class="mt-5 d-flex justify-content-center">
        <b-spinner label="Loading..." variant="dark" />
      </div>

      <div v-if="posts && posts.length">
        <BaseLists
          :items="posts"
          item-class="list__post-item"
          :is-loading="isLoading"
          :no-more-item="noMoreItem"
          :enable-cursor-pointer="false"
          :show-detail="false"
          :toggle-fetching="false"
          default-class=""
          @clickItem="goNextPage($event)"
          @fetchNewItems="fetchPosts"
        >
          <!-- <template v-slot:alert="posts">
            <post-conflict-alert
              :show="
                posts.item && isPostsConflict && isPostsConflict[posts.item.id]
              "
              :section="section"
              :post="posts.item"
              :conflict-type="conflictType[posts.item.id]"
            >
            </post-conflict-alert>

            <AlertWaitingPublishPost
              :post="posts.item"
              :postSchedule="getPostSchedule(posts.item.id, section.id)"
            />
          </template> -->

          <template v-slot:list-item="{ posts: postData = {} }">
            <post-list-item
              :learning-unit="learningUnit"
              :post="postData.item"
              :post-schedule="getPostSchedule(postData.item.id, section.id)"
              :section="section"
              :disabled="disabled"
              :show-options="editable"
              @emitDeletePost="emitDeletePost"
            />
          </template>
        </BaseLists>
      </div>

      <div v-if="!posts.length && !isLoading" class="text-dark mt-4">No Post</div>
    </b-col>
  </b-row>
</template>

<script>
import _ from 'lodash';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import BaseLists from '@/components/base-components/BaseLists';
import Vimeo from '@/models/Vimeo';
import Post from '@/models/Post';
import LearningUnit from '@/models/LearningUnit';
import PostSchedule from '@/models/PostSchedule';
import User from '@/models/User';
// import PostConflictAlert from "@/components/Post/PostConflictAlert";
// import AlertWaitingPublishPost from "@/components/Post/AlertWaitingPublishPost";
import PostListItem from '@/components/Post/PostListItem';

export default {
  components: {
    BaseLists,
    // PostConflictAlert,
    PostListItem
    // AlertWaitingPublishPost,
  },

  mixins: [datetimeMixin],

  props: {
    user: {
      type: User,
      required: true
    },

    learningUnit: {
      type: LearningUnit,
      required: true
    },
    section: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: [Number, Boolean],
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      // posts: [],
      userEnrolls: [],
      endUserEnrolls: [],
      noMoreItem: false,
      isPostsConflict: {},
      conflictType: {},
      postScheduleMapping: {}
    };
  },

  computed: {
    filterDescription() {
      if (this.clickShowMore) {
        return this.description;
      }
      return this.description.substring(0, 1000) + '...';
    },

    sectionId() {
      return this.$route.params.sectionId;
    },

    editable() {
      console.log(this.learningUnit, this.user);
      return this.learningUnit.canEdit(this.user.id) || this.user.isRole('reviewer');
    },

    posts() {
      const { postScheduleMapping = {} } = this;

      const postIds = Object.keys(postScheduleMapping)
        .map((mapping) => {
          const splitted_mapping = mapping.split('_');
          const postId = splitted_mapping[0];

          return parseInt(postId);
        })
        .filter(Boolean);

      let posts = Post.query().withAll().whereIdIn(postIds).get();

      posts = _.sortBy(posts, (post) => {
        const postSchedule = post.post_schedules.find(
          (postSchedule) => (postSchedule.section_id = this.section.id)
        );

        return postSchedule.published_at === null ? 0 : postSchedule.published_at;
      });

      return posts;
    }
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler: 'onRouteChanged'
    }
  },

  methods: {
    // async fetchCheckConflict(learningUnitId) {
    //   if (!learningUnitId) return;

    //   try {
    //     let conflict = await LearningUnit.api().getConflictBetweenSectionAndPost(
    //       learningUnitId
    //     );

    //     if (conflict && conflict[this.sectionId]) {
    //       const { post, conflictType } = conflict[this.sectionId];

    //       this.isPostsConflict = post;
    //       this.conflictType = conflictType;
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },

    async onRouteChanged() {
      await Promise.all([
        this.fetchPosts()
        // this.fetchCheckConflict(this.learningUnit.id),
      ]);
    },

    goToCreatePost() {
      this.$router.push({
        name: 'design-planning/post/create',
        params: { sectionId: this.sectionId },
        query: {
          previousPath: this.$route.fullPath,
          view: 'list'
        }
      });
    },

    // getPostTitle(str) {
    //   return str ? str : "Untitled";
    // },

    // goToCreatePost() {
    //   this.$router.push({
    //     name: "design-planning/post/create",
    //   });
    // },

    // goToEditPost(post_id) {
    //   this.$router.push({
    //     name: "design-planning/post/edit",
    //     params: {
    //       learningUnitId: this.learningUnit.id,
    //       sectionId: this.sectionId,
    //       postId: post_id,
    //     },
    //     query: {
    //       previousPath: this.$route.fullPath,
    //     },
    //   });
    // },

    goNextPage(event) {
      console.log(event);
    },

    getPostSchedule(postId, sectionId) {
      const postScheduleId = this.postScheduleMapping[`${postId}_${sectionId}`];

      return PostSchedule.find(postScheduleId);
    },

    async fetchPosts() {
      this.isLoading = true;
      this.noMoreItem = false;

      if (!this.learningUnit && !this.learningUnit.id) return;

      try {
        let { response } = await PostSchedule.api().findForTeacher(this.sectionId);

        if (response.data && response.data.length) {
          // let post_list = map(response.data, "post");

          response.data.forEach(({ id, post, section } = {}) => {
            this.$set(this.postScheduleMapping, `${post.id}_${section}`, id);
          });

          // this.posts = [...this.posts, ...post_list];

          // this.posts.forEach((post) => {
          //   if (post.vimeo_id) {
          //     post.vimeo = Vimeo.query().where("id", post.vimeo_id).first();
          //   }
          // });

          this.checkVideoStatus();

          this.isLoading = false;
        } else {
          this.noMoreItem = true;

          this.isLoading = false;

          return;
        }
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }
    },

    checkVideoStatus() {
      // Check video status is ready?
      const postWithVideo = this.posts.filter((post) => {
        return post.vimeo;
      });
      postWithVideo.forEach(async (post) => {
        if (post.vimeo.isVideoAvailable === false) {
          await Vimeo.api().getVideoInformation(post.vimeo.id);
        }
      });
    },
    showModal(modalType) {
      this.$refs[modalType].show(modalType);
    },
    emitDeletePost(postId) {
      this.posts = this.posts.filter((post) => post.id !== postId);
    }
    // async ReorderItems(items) {
    //   try {
    //     this.isLoading = true;

    //     this.posts = [];

    //     await Post.api().updateOrder(items);

    //     this.posts = items;
    //     this.postsForReorder = items;
    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //     console.log(error);
    //   }
    // },
  }
};
</script>
